import { List, New, Edit, UserGroup, MenuAccess } from "../Components";

export default [
    {
        path: "/admin/setting/leave-approval-list",
        component: List,
        name: "setting.leave-approval-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/leave-approval-new",
        component: New,
        name: "setting.leave-approval-new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/leave-approval/:id/edit",
        component: Edit,
        name: "setting.leave-approval-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave/setting/group",
        component: UserGroup,
        name: "setting.leave-user-menu",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave/setting/menu-permission",
        component: MenuAccess,
        name: "setting.leave.menu.permission",
        meta: {
            requiresAuth: true,
        },
    },
];
